<div id="theRoleForm">
    <span *ngIf="title" class="mat-title">{{title}}</span>
    <div *ngIf="role" class="content pb-0 m-0" fusePerfectScrollbar>

        <form [formGroup]="contactForm">

            <div class="flex flex-row gap-1 items-start">
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex-1">
                    <mat-label>Nombre</mat-label>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <input name="name" formControlName="name" matInput required>
                </mat-form-field>
                <div class="flex-[0_0_25%]" *ngIf="!(_systemService.visibility.roleEstimations)">
                    <mat-form-field dense appearance="outline" class="w-full">
                        <mat-label>Valor Hora</mat-label>
                        <mat-icon matSuffix class="secondary-text">attach_money</mat-icon>
                        <input name="hourIncome" formControlName="hourIncome" matInput type="number">
                    </mat-form-field>
                </div>
            </div>
            <div class="flex flex-row items-start">
                <mat-form-field dense appearance="outline" class="flex-1">
                    <mat-label>Descripción</mat-label>
                    <textarea name="description" formControlName="description" matInput></textarea>
                </mat-form-field>
            </div>

            <div class="flex flex-row items-start">
                <mat-form-field dense appearance="outline" class="flex-1">
                    <mat-label>Templates autorizados</mat-label>
                    <mat-chip-list #chipList aria-label="Templates autorizados">
                        <mat-chip *ngFor="let t of allowedTemplatesArr" [selectable]="false" [removable]="true" (removed)="removeTemplate(t)">
                            {{t}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input
                            [formControl]="templateCtrl"
                            [matAutocomplete]="auto"
                            [matChipInputFor]="chipList"
                            (keyup.enter)="addTemplate(templateCtrl.value)"
                            matInput
                            placeholder="Agregar template" />
                    </mat-chip-list>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addTemplate($event.option.value)">
                        <mat-option *ngFor="let option of filteredReportNames$ | async" [value]="option">{{option}}</mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <!-- <div class="flex flex-row items-start"> -->
            <!-- <material-dual-listbox #dualList [source]="allPermissions" [(destination)]="role.permissions"></material-dual-listbox> -->
            <div class="flex items-start w-full">
                <h3>Permisos:</h3>
            </div>
            <dual-list #dualList [source]="allPermissions" [(destination)]="role.permissions" key="id"
                       display="name" [format]="format" height="200px"></dual-list>
            <!-- </div> -->
            <div class="flex items-start w-full">
                <h3>Usuarios:</h3>
            </div>
            <dual-list [source]="users" [(destination)]="role.users" key="id"
                       display="name" [format]="format" height="200px"></dual-list>

        </form>
        <div *ngIf="_systemService.canAction('adminRoles')" class="m-0 p-16 flex flex-row justify-end items-center">
            <button *ngIf="action !== 'edit'"
                    mat-button mat-raised-button color="accent" class="save-button"
                    (click)="guardarRole()"
                    [disabled]="contactForm.invalid"
                    aria-label="SAVE">
                Guardar
            </button>
        </div>
    </div>

    <div *ngIf="!role">
        <span>Debe seleccionar un rol para modificar o presionar 'Nuevo' para crear un rol nuevo</span>
    </div>

</div>
